var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoAudi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104,
    height: 105,
    viewBox: "0 0 104 105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_309",
    "data-name": "Grupo 309",
    transform: "translate(-1012 -2573)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_126",
    "data-name": "Rect\\xE1ngulo 126",
    width: 104,
    height: 105,
    rx: 10,
    transform: "translate(1012 2573)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "logo_audi",
    d: "M57.3,0a12.565,12.565,0,0,0-7.47,2.464,12.557,12.557,0,0,0-14.94,0,12.557,12.557,0,0,0-14.94,0A12.5,12.5,0,0,0,0,12.318,12.414,12.414,0,0,0,12.476,24.635a12.565,12.565,0,0,0,7.47-2.464,12.557,12.557,0,0,0,14.94,0,12.388,12.388,0,0,0,7.47,2.464,12.565,12.565,0,0,0,7.47-2.464,12.5,12.5,0,0,0,19.946-9.854A12.414,12.414,0,0,0,57.3,0Zm-7.47,18.675a9.55,9.55,0,0,1,0-12.715,9.55,9.55,0,0,1,0,12.715Zm-14.94,0a9.549,9.549,0,0,1,0-12.715,9.55,9.55,0,0,1,0,12.715Zm-14.94,0a9.55,9.55,0,0,1,0-12.715,9.575,9.575,0,0,1,2.424,6.357A9.38,9.38,0,0,1,19.946,18.675ZM2.583,12.318A9.914,9.914,0,0,1,18,4.252a12.162,12.162,0,0,0,0,16.132,10.055,10.055,0,0,1-5.523,1.669A9.836,9.836,0,0,1,2.583,12.318Zm19.311,8.066a12.162,12.162,0,0,0,0-16.132,10.055,10.055,0,0,1,5.523-1.669,9.741,9.741,0,0,1,5.523,1.669,12.121,12.121,0,0,0-3.1,8.066,11.927,11.927,0,0,0,3.1,8.066,9.974,9.974,0,0,1-11.046,0Zm14.94,0a12.121,12.121,0,0,0,3.1-8.066,11.927,11.927,0,0,0-3.1-8.066,10.055,10.055,0,0,1,5.523-1.669,9.741,9.741,0,0,1,5.523,1.669,12.121,12.121,0,0,0-3.1,8.066,11.927,11.927,0,0,0,3.1,8.066,9.974,9.974,0,0,1-11.046,0ZM57.3,22.052a9.835,9.835,0,0,1-5.523-1.669,12.121,12.121,0,0,0,3.1-8.066,11.927,11.927,0,0,0-3.1-8.066A10.055,10.055,0,0,1,57.3,2.583a9.836,9.836,0,0,1,9.894,9.735A9.836,9.836,0,0,1,57.3,22.052Z",
    transform: "translate(1029.736 2613.317)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAudi);
export default __webpack_public_path__ + "static/media/ico_audi.b2657ba2317123ce9e8b331d6934a8c0.svg";
export { ForwardRef as ReactComponent };